import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fetchPotentialLeaguesForCloningMergedParams } from '../reducers/potential_leagues_for_cloning'
import {
  selectProductType,
  selectSeason,
  selectTour,
  selectCategory,
  selectTextSearch,
  serializeFilters,
} from '../reducers/leagues_filter_values'

const useRefetchLeagues = () => {
  // Prevent eager fetching
  const firstRender = React.useRef(true)
  const dispatch = useDispatch()

  // Selected filters
  const textSearch = useSelector(selectTextSearch)
  const category = useSelector(selectCategory)
  const productType = useSelector(selectProductType)
  const season = useSelector(selectSeason)
  const tour = useSelector(selectTour)

  // Refetch data every time one of the filters change
  React.useEffect(() => {
    // Prevent refetching on first render
    if (firstRender.current) {
      return
    }

    dispatch(fetchPotentialLeaguesForCloningMergedParams(
      serializeFilters(productType, category, season, tour, textSearch),
    ))
  }, [ dispatch, category, productType, season, tour, textSearch ])

  // Capture first render
  React.useEffect(() => {
    firstRender.current = false
  }, [])
}

export default useRefetchLeagues
